import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const CustomTextProgressbar = (props) => {
  const { children, ...otherProps } = props;

  return (
    <>
      <div style={{ position: "absolute" }}>
        <CircularProgressbar
          value={{ ...otherProps }.percentage}
          maxValue={100}
          styles={buildStyles({
            strokeLinecap: "butt",
          })}
        />
      </div>
      <div
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {props.children}
      </div>
    </>
  );
};

export default CustomTextProgressbar;
